import { PATTERN_TYPES } from '../../constants/pattern-types'
import submissionSelectors from './submission.selectors'
import { createSelector } from '@reduxjs/toolkit'

const patternSelectors = {
    all: state => state.assignment.assignment.patterns,
    byId: state => id => state.assignment.assignment.patterns?.find(pattern => pattern.motif_id === id),
    fineTunedPatterns: state =>
        state.assignment.assignment.patterns.filter(pattern => pattern.type === PATTERN_TYPES.FINETUNED.value),
    lbePatternsWithoutAlreadyPresentOnOpenedSubmission: createSelector(
        [state => state.assignment.assignment.patterns, submissionSelectors.openedSubmissionPatterns],
        (patterns, openedSubmissionPatterns) =>
            patterns?.filter(
                pattern =>
                    pattern.type === PATTERN_TYPES.LBE.value &&
                    !openedSubmissionPatterns.some(openedPattern => openedPattern.motif_id === pattern.motif_id),
            ),
    ),
    pendingApprovalPatternId: state => state.pattern.pendingApprovalPatternId,
    editingPattern: state => {
        const editingPattern = state.assignment.editingPattern || {}
        const editingPatternDetails =
            state.assignment.assignment.patterns?.find(
                motif => motif.motif_id === state.assignment.editingPattern?.id,
            ) || {}
        return {
            ...editingPattern,
            ...editingPatternDetails,
        }
    },
    editingPatternId: state => patternSelectors.editingPattern(state)?.id,
    editingPatternCriteria: state =>
        patternSelectors.editingPattern(state)?.query
            ? JSON.parse(patternSelectors.editingPattern(state)?.query)
            : null,
    numberOfSubmissionsHitByEditingPattern: state => {
        const patternId = patternSelectors.editingPattern(state)?.motif_id
        return state.assignment.clusters?.reduce((acc, cluster) => {
            cluster.files.map(file => {
                if (file.motifList.some(pattern => pattern.motif_id === patternId)) {
                    acc++
                }
            })
            return acc
        }, 0)
    },
    numberOfSemanticPatterns: state =>
        state.assignment.assignment.patterns?.filter(pattern => pattern.type === PATTERN_TYPES.SEMANTIC.value).length,
    semanticPatternExists: state =>
        state.assignment.assignment.patterns?.some(pattern => pattern.type === PATTERN_TYPES.SEMANTIC.value),
    finetunedPatternExists: state =>
        state.assignment.assignment.patterns?.some(pattern => pattern.type === PATTERN_TYPES.FINETUNED.value),
}

export default patternSelectors
